import * as React from "react";
const SvgFileBlank = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 4, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28,7h23v50h-38v-35zm1,0v16h-16" }));
export default SvgFileBlank;
